window.onload = function () {
    initMap();
}

function initMap() {
    let markersArray = [];
    let mapOptions = {
        center: new google.maps.LatLng(markers[0].lat, markers[0].lng),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var latlngbounds = new google.maps.LatLngBounds();
    var map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);

    let marker229;

    map.set('styles', [
        {
            'featureType': 'administrative',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': '-100'
                }
            ]
        },
        {
            'featureType': 'administrative.province',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': -100
                },
                {
                    'lightness': 80
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': -100
                },
                {
                    'lightness': '50'
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': '-100'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'all',
            'stylers': [
                {
                    'lightness': '30'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'all',
            'stylers': [
                {
                    'lightness': '40'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': -100
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#c9d2d3'
                },
                {
                    'lightness': 45
                },
                {
                    'saturation': -90
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'labels',
            'stylers': [
                {
                    'lightness': -25
                },
                {
                    'saturation': -100
                }
            ]
        }
    ]);

    for (var i = 0; i < markers.length; i++) {
        var data = markers[i]
        var myLatlng = new google.maps.LatLng(data.lat, data.lng);
        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: data.title,
            data: data,
            url: data.url,
            filter: data.filter,
            icon: data.icon,
            hover: data.hover
        });

        (function (marker, data) {
            google.maps.event.addListener(marker, 'click', function () {
                window.location.href = this.url;
            });
        })(marker, data);
        latlngbounds.extend(marker.position);
        markersArray.push(marker);
    }

    map.setCenter(latlngbounds.getCenter());
    map.fitBounds(latlngbounds);

    let offsetX = 400;

    if (document.body.clientWidth < 1023) {
        offsetX = 0;
    }

    // Idle callback is needed after FitBounds else the zoom will not be taken into effect.
    google.maps.event.addListenerOnce(map, 'idle', () => {
        offsetCenter(map, latlngbounds.getCenter(), offsetX, 0);
    });

    function offsetCenter(map, latlng, offsetx, offsety) {
        map.setCenter(latlng);
        map.panBy(offsetx, offsety);
    }

    // hide or show dealer info based on markers that in view.
    map.addListener('bounds_changed', function () {
        let checkboxes = document.querySelectorAll('input[name="product"]:checked');

        for (var i = markersArray.length, bounds = map.getBounds(); i--;) {
            let locationItem = document.getElementById('loc' + markersArray[i].data.id);
            locationItem.style.display = 'none';
            let distance;

            var listItems = document.querySelectorAll('.location-list .location');
            listItems.forEach(function (item) {
                var dataNum = '';

                item.addEventListener('mouseover', function () {
                    var dataNum = this.getAttribute('data-num');
                    markersArray[dataNum].setIcon(data.hover);
                });

                item.addEventListener('mouseout', function () {
                    var dataNum = this.getAttribute('data-num');
                    markersArray[dataNum].setIcon(data.icon);
                });
            });

            if (bounds !== undefined && bounds.contains(markersArray[i].getPosition())) {
                if (typeof marker229 != 'undefined') {
                    distance = getDistance(markersArray[i].position, marker229.getPosition());
                    locationItem.querySelector('.distance').innerText = Math.ceil(distance) + 'KM';
                    locationItem.style.order = Math.ceil(distance);
                }

                if (checkboxes.length > 0) {
                    if (markersArray[i].data.products) {
                        for (var j = 0; j < checkboxes.length; j++) {
                            if (markersArray[i].data.products.includes(checkboxes[j].value)) {
                                markersArray[i].setMap(map);
                                locationItem.style.display = '';
                            }
                        }
                    }
                }

                if (checkboxes.length == 0) {
                    if (bounds.contains(markersArray[i].getPosition())) {
                        markersArray[i].setMap(map);
                        locationItem.style.display = '';
                    }
                }
            }
        }
    });

    // add eventlisteners for the products
    const filterProducts = document.querySelectorAll('.filters input[name="product"]');
    for (let i = 0; i < filterProducts.length; i++) {
        filterProducts[i].addEventListener('change', function () {
            showMarkers()
        });
    }

    // Sets the map on all markers in the array.
    function setMapOnAll(map) {
        for (let i = 0; i < markersArray.length; i++) {
            markersArray[i].setMap(null);
        }
        google.maps.event.trigger(map, 'bounds_changed');
    }

    // Shows any markers currently in the array.
    function showMarkers() {
        setMapOnAll(map);
    }

    var listItems = document.querySelectorAll('.location-list .location');
    listItems.forEach(function (item) {
        var dataNum = '';

        item.onclick = function (e) {
            var dataNum = this.getAttribute('data-num');
            google.maps.event.trigger(markers[dataNum], 'click');
        };
    });

    let input = document.getElementById('addressInput');
    var autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);
    autocomplete.addListener('place_changed', function () {

        let place = autocomplete.getPlace();
        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            // window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(10);
        }

        geocodeAddress(geocoder, map);
        map.setZoom(10);
    });

    input.addEventListener('keydown', (evt) => {
        if (evt.which === 13) {
            evt.preventDefault();
            geocodeAddress(geocoder, map);
            map.setZoom(10);
        }
    });

    let geocoder = new google.maps.Geocoder();

    function geocodeAddress(geocoder, map) {
        let address = document.getElementById('addressInput').value;

        geocoder.geocode({
                'address': address,
            },
            function (results, status) {
                if (status === 'OK') {
                    map.setCenter(results[0].geometry.location);

                    let infowindow229 = new google.maps.InfoWindow({
                        content: address
                    });

                    marker229 = new google.maps.Marker({
                        position: results[0].geometry.location,
                        map: map,
                        title: address
                    });
                    marker229.addListener('click', function () {
                        infowindow229.open(map, this);
                    });

                    map.setCenter(results[0].geometry.location);

                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            }
        );
    }

    // function that calculates the distance between two lng lat values
    function getDistance(latlng1, latlng2) {
        var R = 6371;
        var dLat = (latlng2.lat() - latlng1.lat()) * Math.PI / 180;
        var dLon = (latlng2.lng() - latlng1.lng()) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(latlng1.lat() * Math.PI / 180) * Math.cos(latlng2.lat() * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    showMarkers();
}
